import { useOutletContext } from 'react-router-dom'

import { useDocumentTitle } from 'usehooks-ts'

import { useClientSideFeatureFlag } from 'modules/core/lib/clientSideFeatureFlags'
import i18n from 'modules/core/lib/i18n'

import EmployeesList from 'modules/employees/components/EmployeesList'
import type { RouteContextParams } from 'modules/employees/lib/RouteContextParams'

import EmployeeCollection from '../components/EmployeeCollection'

const EmployeesListPage = () => {
  const { filtersForm } = useOutletContext<RouteContextParams>()
  const { isFeatureFlagEnabled } = useClientSideFeatureFlag()

  useDocumentTitle(i18n.t('employees.title'), {
    preserveTitleOnUnmount: false,
  })

  if (isFeatureFlagEnabled('employee-data-collection')) {
    return <EmployeeCollection />
  }

  return <EmployeesList filtersForm={filtersForm} />
}

export default EmployeesListPage
